<script setup>
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const formatDate = dateString => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return 'N/A';
  return format(date, 'HH:mm:ss, dd/MM/yyyy');
};

const meta = props.event.meta || {};
const deletedBy = meta.deleted_by_user_name;
const deletedAt = meta.deleted_at || props.event.created_at;
const slaPolicyName = meta.sla_policy_name || meta.name || 'N/A';
</script>

<template>
  <div
    class="bg-n-solid-2 rounded-lg border-l-4 border-red-500"
    :class="compact ? 'p-2 pr-8' : 'p-4'"
  >
    <div class="mb-1 text-xs">
      <div class="font-medium text-n-slate-12 mb-0.5">
        {{ slaPolicyName }} {{ t('TICKETS.SLA.DELETED')
        }}{{ t('TICKETS.COLON') }}
      </div>
      <div class="text-n-slate-11">
        {{ formatDate(deletedAt) }}
      </div>
    </div>

    <div v-if="deletedBy" class="text-xs text-n-slate-11 mb-1">
      <div class="font-medium text-n-slate-12">
        {{ t('TICKETS.SLA.DELETED_BY') }}{{ t('TICKETS.COLON') }}
      </div>
      <div class="text-n-slate-11">
        {{ deletedBy }}
      </div>
    </div>
  </div>
</template>
